import { getField, updateField } from "vuex-map-fields";

const getDefaultState = () => {
  return {
    Toast: {
      isOpen: false,
      contents: "",
    },
    /**
     * mOTP 존재 여부
     */
    mOtpExstYN: "N",
    /**
     * 재등록 대상 OTP목록조회
     */
    RBF0602L40: {
      in: {
        otpSerno: "", //선택된 OTP일련번호
        otpVndrDsticCd: "", //선택된 OTP벤더구분코드
        mgrUid: "", //사용자식별자
      },
      out: {
        success: {
          otpListGrid: [
            // {
            //   otpSerno: "", //OTP일련번호
            //   otpVndrDsticCd: "", //OTP벤더구분코드
            //   otpRegYn: "", //OTP등록여부
            //   userIdnfr: "", //사용자식별자
            //   userName: "", //사용자명
            //   lginPtimOtpUseYn: "", //로그인시OTP사용여부
            //   otpStsCd: "", //OTP상태구분
            // },
          ],
        },
        fail: {},
      },
    },
    /**
     * 고객정보조회 + mOTP Info
     */
    RBF0409E40: {
      in: {},
      out: {
        success: {
          cphnNo: "", // 휴대폰 번호
          emad1: "", // 이메일 주소
          celNomalSendzYn: "", // 휴대전화정상송신여부(0/1) 휴대전화번호를 고객이 검증했는지 여부
          celRecvCnsntYn: "", // 휴대전화수신동의여부(0/1) 휴대전화 문자수신 동의 여부
          emailNomalSendzYn: "", // 이메일정상송신여부(0/1) 이메일주소를 고객이 검증했는지 여부
          emailRecvCnsntYn: "", // 이메일수신동의여부(0/1) 이메일 문자수신 동의 여부
          certnNatnlCd: "", // 인증국가코드
          certnCphnNo: "", // 인증국가코드
          otpUniqIdnfiNo: "", // 보안장치고유식별번호
          scurtyDeviVndrDstcd: "", // 보안장치벤더구분코드
          mOtpId: "", //mOTP ID
          systemId: "", //system ID
          mOtpInfo: {
            operGroupCd: "", //운영그룹코드
            iD: "", //mOTP ID
            otpStusDstcd: "", //OTP상태구분코드
            coprPpsnDstcd: "", //법인개인구분코드
            cin: "", //고객정보번호
            mchtlUniqNo: "", //기기고유번호
            smphMchtlUniqNo: "", //스마트폰기기고유번호
            smphMchtlDstcd: "", //스마트폰기기구분코드
            pgmVsnno: "", //프로그램버전번호
            certnDmndCd: "", //인증요청코드
            smphMdelName: "", //스마트폰모델명
            pinFailNotms: 0, //핀실패횟수
            certnErrNotms: 0, //인증오류횟수
            totalCertnSucssNotms: 0, //총인증성공횟수
            totalCertnErrNotms: 0, //총인증오류횟수
            issuncLcalYMS: "", //발급현지일시
            issuncYMS: "", //발급일시
            frstCertnSucssLcalYMS: "", //최초인증성공현지일시
            frstCertnSucssYMS: "", //최초인증성공일시
            lastCertnDmndLcalYMS: "", //최종인증요청현지일시
            lastCertnSucssLcalYMS: "", //최종인증성공현지일시
            lastCertnErrLcalYMS: "", //최종인증오류현지일시
            lastCertnDmndYMS: "", //최종인증요청일시
            lastCertnSucssYMS: "", //최종인증성공일시
            lastCertnErrYMS: "", //최종인증오류일시
            writYMS: "", //작성일시
            lastAmndYMS: "", //최종수정일시
            systemId: "", // mOTP systemId
          }, // mOtp원장 정보
        },
        fail: {},
      },
    },
    /**
     * mOTP 기기정보
     */
    SSInfogetMotp: {
      in: {},
      out: [
        // {
        // 	strUserId: "G21000009100000"
        // , secret: "dfefewfsdfadsafasdfasdfsdf...."
        // }
      ],
    },
    /**
     * Token OTP 재등록완료
     * 사용전문 : RBF0602L60
     */
    finishOTP: {
      in: {
        otpSerno: "", //OTP일련번호
        otpVndrDsticCd: "", //OTP벤더구분코드
        uid: "", //사용자식별자
        dailyTrsaccClam: "", //일일이체한도금액
        casPerTrsaccClam: "", //건별이체한도금액
        result: "",
        secret: "",
        errorcode: "",
      },
      out: {
        success: {
          otpSerno: "", // 보안장치고유식별번호
          otpVndrDsticCd: "", // 보안장치벤더구분코드
          issuncYms: "", //OTP 발급일시
          regiYms: "", //OTP 등록일시
          mOtpInfo: {
            iD: "", //mOTP ID
            otpStusDstcd: "", //OTP상태구분코드
            mchtlUniqNo: "", //기기고유번호
            issuncLcalYMS: "", //발급현지일시
            issuncYMS: "", //발급일시
            smphMchtlUniqNo: "", //스마트폰기기고유번호
            smphMchtlDstcd: "", //스마트폰기기구분코드
            pgmVsnno: "", //프로그램버전번호
            certnDmndCd: "", //인증요청코드
            smphMdelName: "", //스마트폰모델명
            lastCertnSucssLcalYMS: "", //최종인증성공현지일시
            lastCertnErrLcalYMS: "", //최종인증오류현지일시
            writYMS: "", //작성일시
            lastAmndYMS: "", //최종수정일시
          }, // mOtp원장 정보
        },
        fail: {},
      },
    },
  };
};

const reregisterOtp = {
  namespaced: true,
  state: getDefaultState(),
  getters: {
    getField,
    getToast: state => {
      return state.Toast;
    },
    /**
     * 재등록 대상 OTP목록
     */
    getRBF0602L40: state => {
      return state.RBF0602L40;
    },
    /**
     * 고객정보 + mOTPInfo
     */
    getRBF0409E40: state => {
      return state.RBF0409E40;
    },
    /**
     * mOTP 기기정보(native)
     */
    getSSInfogetMotp: state => {
      return state.SSInfogetMotp;
    },
    /**
     * Token OTP 재발급완료
     */
    getFinishOTP: state => {
      return state.finishOTP;
    },
    /**
     * mOTP 모바일내 존재여부
     */
    getMotpExstYN: state => {
      return state.mOtpExstYN;
    },
  },
  mutations: {
    updateField,
    resetState: state => {
      Object.assign(state, getDefaultState());
    },
    /**
     * mOTP 기기정보
     */
    mutSSInfogetMotp: function(state, payload) {
      state.SSInfogetMotp.out = [];
      payload.Motpinfo.length > 0 &&
        payload.Motpinfo.forEach(e => {
          state.SSInfogetMotp.out.push(e);
        });
    },
    /**
     * 재등록 대상 OTP목록
     */
    mutRBF0602L40: function(state, payload) {
      this._vm.$set(state.RBF0602L40.in, payload.key, payload.value);
    },
    /**
     * mOTP 인증 요청
     */
    mutSSGenerateMotp: function(state, payload) {
      this._vm.$set(state.SSGenerateMotp, payload.key, payload.value);
    },
    /**
     * Token OTP 재발급완료
     */
    mutfinishOTP: function(state, payload) {
      this._vm.$set(state.finishOTP.in, payload.key, payload.value);
    },
  },
  actions: {
    /**
     * 고객정보조회 + mOTP Info
     */
    actRBF0409E40: function (context) {
      return new Promise(resolve => {
        this._vm.$post(
          "/auth/motp/otpreregi/RBF0409E40",
          context.state.RBF0409E40.in,
          response => {
            this._vm.$set(this.state.auth.reregisterOtp.RBF0409E40.out, "success", response);
            resolve("success");
          },
          response => {
            this._vm.$set(this.state.auth.reregisterOtp.RBF0409E40.out, "fail", response);
            resolve("fail");
          },
        );
      });
    },
    /**
     * 재등록 대상 OTP목록조회
     */
    actRBF0602L40: function (context) {
      return new Promise(resolve => {
        // 사용자식별자(UID)
        this.state.auth.reregisterOtp.RBF0602L40.in.mgrUid = this.state.sessionInfo.userInfo.userIdnfr;

        this._vm.$post(
          "/auth/motp/otpreregi/RBF0602L40",
          this.state.auth.reregisterOtp.RBF0602L40.in,
          response => {
            this._vm.$set(this.state.auth.reregisterOtp.RBF0602L40.out, "success", response);

            // token otp set
            if (this.state.auth.reregisterOtp.RBF0602L40.out.success.otpListGrid.length > 0) {
              context.commit("mutRBF0602L40", { key: "otpSerno", value: this.state.auth.reregisterOtp.RBF0602L40.out.success.otpListGrid[0].otpSerno });
            }

            // 은행이체한도 set
            for (const k in response) {
              if (k != "otpListGrid") context.commit("auth/createMotp/mut012", { key: k, value: response[k] }, { root: true });
            }
            context.rootState.auth.createMotp.dailyminMaxInfo[this.state.siteCode].simpleBtnArr.forEach(e => {
              if (e.view === "MAX") {
                e.amt = response.dailyTrsaccClam;
              }
            });
            context.rootState.auth.createMotp.casPerminMaxInfo[this.state.siteCode].simpleBtnArr.forEach(e => {
              if (e.view === "MAX") {
                e.amt = response.casPerTrsaccClam;
              }
            });

            resolve("success");
          },
          response => {
            this._vm.$set(this.state.auth.reregisterOtp.RBF0602L40.out, "fail", response);
            resolve("fail");
          },
        );
      });
    },
    /**
     * Token OTP 재등록
     */
    actFinishOTP: function () {
      return new Promise(resolve => {
        this.state.auth.reregisterOtp.finishOTP.in.otpVndrDsticCd = this._vm.$config.SCURTY_DEVI_VNDR_VASCO_TOKEN;

        this._vm.$post(
          "/auth/motp/otpreregi/finishOTP",
          this.state.auth.reregisterOtp.finishOTP.in,
          response => {
            this.state.sessionInfo.userInfo.otpUniqIdnfiNo = response.outItem.otpSerno;
            this.state.sessionInfo.userInfo.scurtyDeviVndrDstcd = response.outItem.otpVndrDsticCd;
            this._vm.$set(this.state.auth.reregisterOtp.finishOTP.out, "success", response.outItem);
            resolve("success");
          },
          response => {
            this._vm.$set(this.state.auth.reregisterOtp.finishOTP.out, "fail", response);
            resolve("fail");
          },
        );
      });
    },
    /**
     * 기기정보와 mOTP INFO 비교 검증
     */
    actCheckMotpInfo: function() {
      // 현재 폰에 정상인 mOTP가 있는 경우. (인증오류해제는 상태가 030 아님 ,예외처리로 인증가능함 )
      if (
        this.state.auth.reregisterOtp.SSInfogetMotp.out.filter(item => {
          return item.strUserId === this.state.auth.reregisterOtp.RBF0409E40.out.success.mOtpId;
        }).length > 0 &&
        this.state.auth.reregisterOtp.RBF0409E40.out.success.mOtpInfo.otpStusDstcd === "030" &&
        this.state.auth.reregisterOtp.RBF0409E40.out.success.mOtpInfo.smphMchtlUniqNo === this.state.native.smphMchtlUniqNo
      ) {
        // console.log("[reregisterOtp] OK---->현재 폰에 정상인 mOTP가 있는 경우 ");
        this.state.auth.reregisterOtp.mOtpExstYN = "Y";
      } else {
        // console.log("[reregisterOtp] NO---->현재 폰에 비정상인 mOTP가 있는 경우");
        this.state.auth.reregisterOtp.mOtpExstYN = "N";
      }
    },
  },
};

export default reregisterOtp;
